<template>
  <div>
    <div v-for="timeSlotId in sortedTimeSlotIds" :key="timeSlotId" style="margin-top: 1rem; display: grid; grid-template-columns: 1fr 1fr; column-gap: 1rem; align-content: center;">
      <div style="display: flex; flex-wrap: wrap; column-gap: .5rem; align-items: center;">
        <div style="display: flex; width: 10ch; font-weight: 500;">
          <div style="width: 5ch; text-align: left;">{{ timeRanges[timeSlotId].split('-')[0] }}</div>
          <div style="padding: 0 .5ch">-</div>
          <div style="width: 5ch; text-align: left;">{{ timeRanges[timeSlotId].split('-')[1] }}</div>
        </div>
        <div>{{ getTimeSlotsWeekdays(timeSlotId) }}</div>
      </div>
      <div style="display: flex; gap: .5rem; align-items: center; margin-top: .25rem;">
        <CButton color="primary" :size="buttonSize" @click="$emit('edittimeslot', getTimeSlotById(timeSlotId))">Edit</CButton>
        <CButton color="danger" :size="buttonSize" @click="$emit('deletetimeslot', getTimeSlotById(timeSlotId))">Delete</CButton>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ts-check
import { computed } from 'vue';
/** @typedef {import('@/types').TimeSlot} TimeSlot */
/** @typedef {import('@/types').TimeSlotWithTimeRange} TimeSlotWithTimeRange */

defineEmits(['edittimeslot', 'deletetimeslot']);
const props = defineProps({
  timeSlots: {
    /** @type {import('vue').PropType<TimeSlot[]>} */ 
    type: Array,
    required: true
  },
  buttonSize: {
    type: String,
    default: ''
  },
});

const emptyGuid = "00000000-0000-0000-0000-000000000000";

const formatTimeNumberToString = (num) => {
  return num.toString().padStart(2, '0');
}

const timeRanges = computed(() => {
  /** @type {{[timeSlotId: string]: string}} */
  const groupedObj = {};
  for (const timeSlot of props.timeSlots) {
    if (timeSlot.id !== emptyGuid) {
      const startTime = `${formatTimeNumberToString(timeSlot.start.hours)}:${formatTimeNumberToString(timeSlot.start.minutes)}`;
      const endTime = `${formatTimeNumberToString(timeSlot.end.hours)}:${formatTimeNumberToString(timeSlot.end.minutes)}`;
      const startAndEndTimeFormatted = `${startTime} - ${endTime}`;
      groupedObj[timeSlot.id] = startAndEndTimeFormatted;
    }
  }
  return groupedObj;
});

const sortedTimeSlotIds = computed(() => Object.keys(timeRanges.value).sort((a, b) => {
  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}));

/**
 * @param {string} timeSlotId 
 */
const getTimeSlotsWeekdays = (timeSlotId) => {
  return props.timeSlots.find(timeSlot => timeSlot.id === timeSlotId)?.weekDayNames
    .map((weekDayName) => weekDayName.substring(0, 3))
    .join(', ') || '';
}

/**
 * @param {string} timeSlotId 
 */
const getTimeSlotById = (timeSlotId) => {
  return props.timeSlots.find(timeSlot => timeSlot.id === timeSlotId);
}
</script>